export const GET_MESSAGE_GROUPS_REQ = "GET_MESSAGE_GROUPS_REQ";
export const GET_MESSAGE_GROUPS_SUCCESS = "GET_MESSAGE_GROUPS_SUCCESS";
export const GET_MESSAGE_GROUPS_FAIL = "GET_MESSAGE_GROUPS_FAIL";

export const GET_OVERALL_MESSAGE_GROUPS_SUCCESS =
  "GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS";
export const GET_OVERALL_MESSAGE_GROUPS_FAIL =
  "GET_OVERALL_MESSAGE_SEGMENTS_FAIL";

export const CREATE_MESSAGE_GROUP_REQ = "CREATE_MESSAGE_GROUP_REQ";
export const CREATE_MESSAGE_GROUP_SUCCESS = "CREATE_MESSAGE_GROUP_SUCCESS";
export const CREATE_MESSAGE_GROUP_FAIL = "CREATE_MESSAGE_GROUP_FAIL";
export const CREATE_MESSAGE_GROUP_RESET = "CREATE_MESSAGE_GROUP_RESET";

export const UPDATE_MESSAGE_GROUP_REQ = "UPDATE_MESSAGE_GROUP_REQ";
export const UPDATE_MESSAGE_GROUP_SUCCESS = "UPDATE_MESSAGE_GROUP_SUCCESS";
export const UPDATE_MESSAGE_GROUP_FAIL = "UPDATE_MESSAGE_GROUP_FAIL";
export const UPDATE_MESSAGE_GROUP_RESET = "UPDATE_MESSAGE_GROUP_RESET";

export const DELETE_MESSAGE_GROUP_REQ = "DELETE_MESSAGE_GROUP_REQ";
export const DELETE_MESSAGE_GROUP_SUCCESS = "DELETE_MESSAGE_GROUP_SUCCESS";
export const DELETE_MESSAGE_GROUP_FAIL = "DELETE_MESSAGE_GROUP_FAIL";
